import { render, staticRenderFns } from "./SymmetryViz.vue?vue&type=template&id=ec90cfc8&scoped=true"
import script from "./SymmetryViz.vue?vue&type=script&lang=js"
export * from "./SymmetryViz.vue?vue&type=script&lang=js"
import style0 from "./SymmetryViz.vue?vue&type=style&index=0&id=ec90cfc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec90cfc8",
  null
  
)

export default component.exports